import styled from 'styled-components'
import { rgba } from 'polished'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 70px repeat(
      ${(props) => props.totalEmployees},
      ${(props) => props.collumnSize}px
    );
  background: ${(props) => props.theme.colors.scale[500]};
  position: sticky;
  top: 1px;
  z-index: 6;
  transition: all 50ms linear;
  border-radius: 6px 6px 0 0;
  overflow: hidden;
`

export const HeadItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
  padding: 8px 12px;
  color: #fff;
  background: ${(props) => props.theme.colors.scale[500]};
  border-right: 1px solid ${(props) => rgba('#ffffff', 0.25)};
  transition: background 150ms ease;

  &:last-child {
    border-right: none;
  }

  /* a coluna do relogio acompanha a rolagem lateral */
  &:first-child {
    align-items: center;
    justify-content: center;
    width: 71px;
    position: sticky;
    left: 0;
    top: 0;
    z-index: 2;
  }

  &:hover {
    cursor: pointer;
    background: ${(props) => props.theme.colors.scale[600]};
  }
`

export const TopLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-width: 0;
`

export const Name = styled.strong`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  /* nome comprido corta com reticencias em vez de quebrar a coluna */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Count = styled.span`
  display: grid;
  place-items: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  flex-shrink: 0;
  border-radius: 11px;
  background: ${(props) => rgba('#ffffff', 0.25)};
  color: #fff;
  font-size: 12px;
  font-weight: 700;
`

export const Meta = styled.span`
  font-size: 11px;
  line-height: 1.2;
  color: ${(props) => rgba('#ffffff', 0.85)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`
